import type { UseLeanMutationResult } from '@ztechapps/common.hook'
import { useError, useHistory, useMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { Logistic, RouteDef } from '@ztechapps/common.contract'
import { logisticFragment } from '@ztechapps/logistic.common'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'

export const moveLogisticQuery = gql`
  mutation moveLogistic($input: MoveLogisticServiceArgs!) {
    moveLogistic(input: $input) {
      ...logisticFragment
    }
  }
  ${logisticFragment}
`
export type MoveLogisticsResult = {
  moveLogistic: Logistic
}
export type MoveLogisticsArgs = { sourceLogisticId: string }

export const useMoveLogistic = (): UseLeanMutationResult<MoveLogisticsResult, MoveLogisticsArgs> => {
  const { onError } = useError()
  const history = useHistory()
  const logisctiItemRoute = useInject<RouteDef>(WebuiIocKey.routes.logisticItem)

  const [_moveLogistic, , moveLogisticResult] = useMutation<MoveLogisticsResult, MoveLogisticsArgs>({
    query: moveLogisticQuery,
  })

  const moveLogistic = async (input: MoveLogisticsArgs) => {
    try {
      const moveLogisticsResult = await _moveLogistic({ input, _id: input?.sourceLogisticId })
      const { data, errors } = moveLogisticsResult
      if (errors) throw errors
      const { _id } = data?.moveLogistic ?? {}

      history.push(logisctiItemRoute.altPath({ _id }))
      return moveLogisticsResult
    } catch (e) {
      onError(e)
    }

    return
  }

  return [moveLogistic, moveLogisticResult]
}
